import React from 'react'
import PulseLoader from 'react-spinners/PulseLoader'

const Spinner = ({size}) => {
  return (
    <PulseLoader
        color='#2F80ED'
        speedMultiplier={0.5}
        size={size}
    />
  )
}

export default Spinner